<!-- eslint-disable prettier/prettier -->
<template>
  <card class="card edit-card cardCustom">
    <v-btn class="close-button"
            title="Отменить"
            variant="text"
            text
            @click="close()"
    >
      <v-icon>ti-close</v-icon>
    </v-btn>
    <h4 class="title">Редактирование карточки</h4>
    <div>
      <v-form @submit.prevent ref="form">
        <div class="row">
          <div class="col-6 input-text">
            <label>Имя</label>
            <v-text-field
              type="text" 
              v-model="user.name"
              :rules="textRulesRequire"
              required
            ></v-text-field>
          </div>
          <div class="col-6 input-text">
            <label>Фамилия</label>
            <v-text-field
              v-model="user.lastName"
              :rules="textRules"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6 input-text">
            <label>Отчество</label>
            <v-text-field
              v-model="user.secondName"
              :rules="textRules"
            ></v-text-field>
          </div>
          <div class="col-6 input-text">
            <label>Логин</label>
            <v-text-field
              v-if="user.externalId != '' && user.externalId != undefined"
              v-model="user.login"
              :style="{'color: #b4b4b4': user.externalId != ''}"
              disabled
              required
            ></v-text-field>
            <v-text-field
              v-else
              v-model="user.login"
              :rules="loginRules"
              :style="{'color: #b4b4b4': user.externalId != ''}"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6 input-text">
            <label>E-mail</label>
            <v-text-field
              v-if="user.externalId != '' && user.externalId != undefined"
              v-model="user.email"
              disabled
              required
            ></v-text-field>
            <v-text-field
              v-else
              v-model="user.email"
              :rules="emailRules"
              required
            ></v-text-field>
          </div>
          <div class="col-6 input-text border-input">
            <label>Телефон</label>
            <masked-input 
              mask="\+\7 (111) 111 11-11" 
              v-model="user.phone"
              :rules="textRules"
              @input="rawVal = arguments[1]"
            ></masked-input>
          </div>
        </div>
        <div class="row">
          <div class="col-6 input-text border-input">
            <label>Мобильный телефон</label>
            <masked-input 
              mask="\+\7 (111) 111 11-11" 
              v-model="user.mobile"
              :rules="textRules"
              @input="rawVal = arguments[1]"
            ></masked-input>
          </div>
          <div class="col-6 input-text">
            <label>Telegram</label>
            <v-text-field
              v-model="user.telegram"
              :rules="telegaRules"
            ></v-text-field>
          </div>
        </div>
        <div v-if="user.externalId == ''" class="row">
          <div class="col-12 input-text">
            <label>Руководитель</label>
            <multiselect 
              v-model="value" 
              placeholder="Введите для поиска" 
              label="title" 
              track-by="title"
              :multiple="true"
              :options="options" 
              :option-height="90" 
              :custom-label="customLabel" 
              :close-on-select="false"
              :show-labels="false"
            >
              <span slot="noResult">Нет результатов</span>
              <template slot="singleLabel" slot-scope="props">
                <img class="option__image" :src="props.option.img">
                <span class="option__desc">
                  <span class="option__title">{{ props.option.title }}</span>
                </span>
              </template>
              <template slot="option" style="display:flex" slot-scope="props">
                <div class="option__desc">
                  <img v-if="props.option.img != 'noFoto'" class="option__image select-img" style="margin-right: 10px; border-radius: 30px" :src="props.option.img">
                  <img v-else class="option__image select-img" style="margin-right: 10px; border-radius: 30px" src="@/assets/img/no-foto.png" alt="" />
                  <span class="option__title">{{ props.option.title }}</span>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="text-center">
          <v-btn 
            class="btnSave success-btn primary-btn"
            @click.native.prevent="updateProfile"
          >
            Сохранить
          </v-btn>
        </div>
        <div class="clearfix"></div>
      </v-form>
    </div>
  </card>
</template>
<script>
import MaskedInput from 'vue-masked-input'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import GlobalRequest from "@/plugins/globalRequest"
export default {
  components: {
    MaskedInput,
    Multiselect,
    GlobalRequest
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      emailRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i.test(v)) || 'E-mail некорректен',
      ],
      loginRules: [
        v => !!v || 'Поле обязательно для заполнения',
        v => (/^[-_A-Za-z0-9]+$/i.test(v)) || 'Логин содержит недопустимые символы',
      ],
      telegaRules: [
         v => (/^[-_A-Za-z0-9]*$/i.test(v)) || 'Поле содержит недопустимые символы',
      ],
      textRulesRequire: [
        v => !!v || 'Поле обязательно для заполнения',
        v => (/^[\s\-_A-Яa-я0-9]+$/i.test(v)) || 'Поле содержит недопустимые символы'
      ],
      textRules: [
        v => (/^[\s\-_A-Яa-я0-9]*$/i.test(v)) || 'Поле содержит недопустимые символы'
      ],
      user: this.data,
      selected: null,
      value: [],
      options: [],
      search: "",
    };
  },
  created() {
    this.getHeads()
    this.getPhone()
  },
  methods: {
    getPhone() {
      this.user.phone = this.user.phone.replace("(" , "").replace(")" , "").replace("-" , "").replaceAll(" " , "")
      if(this.user.phone.startsWith("+7")) this.user.phone = this.user.phone.substr(2)
      else if(this.user.phone.startsWith("8")) this.user.phone = this.user.phone.substr(1)

      this.user.mobile = this.user.mobile.replace("(" , "").replace(")" , "").replace("-" , "").replaceAll(" " , "")
      if(this.user.mobile.startsWith("+7")) this.user.mobile = this.user.mobile.substr(2)
      else if(this.user.mobile.startsWith("8")) this.user.mobile = this.user.mobile.substr(1)
    },
    async getHeads() {
      let result = await GlobalRequest.request("/user/list", "GET");
      let items = result.data
      for(let i in items) {
        let user = items[i]
        if(user.active && user.externalId != '') {
          let obj = {}
          obj.title = user.name + " " + user.lastName

          if(user.avatar == "" || user.avatar == undefined || user.avatar == null) {
          obj.img = "noFoto"
          }
          else {
            obj.img = user.avatar
          }
          this.options.push(obj)
        }
      }
      console.log(this.options)

    },
    async updateProfile() {
      let valid = await this.$refs.form.validate()

      if (valid) {
        this.$emit("updateDataUser", this.user)
      }
    },
    close() {
      this.$emit("closeWindow")
      this.user = this.data
    }
  },
};
</script>
<style>
.cardCustom {
  font-family: 'Montserrat', sans-serif;
}
</style>
